import React, { useState } from "react";
import { CgMoreVertical } from "react-icons/cg";
import { FaCircleChevronDown } from "react-icons/fa6";
import defaultPhoto from "../../Assests/images.jpg";
import { addNotificationsForm, updateConfirmUsersForm, updateUsersStatusForm } from "../../lib/actions";
import { useNavigate, useParams } from "react-router-dom";
import InputFieldWithIcon from "../../components/GInput/Input";
import i18n from "../../lib/i18n";
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import NotificationDialog from "../Models/notificationDialog";

export default function ProfileCard ({userData, reload}) {

  const {userId} = useParams();
  const [menuOpen, setMenuOpen] = useState(false);
  const [notificationDialog, setNotificationDialog] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogOpen2, setDialogOpen2] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedReason, setSelectedReason] = useState(null);
  const [selectedText, setSelectedText] = useState("");
  const [selectedAction2, setSelectedAction2] = useState(null);
  const [selectedReason2, setSelectedReason2] = useState(null);
  const [selectedText2, setSelectedText2] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingSend, setLoadingSend] = useState(false);
  const nav = useNavigate();
  const t = i18n.t.bind(i18n); 

  console.log(notificationDialog)

  const toggleSubMenu = (menu) => {
    setOpenSubMenu(openSubMenu === menu ? null : menu);
  };

  const handleSubOptionClick = (action, text) => {
    setSelectedAction(action);
    setSelectedText(text);
    setDialogOpen(true); 
  };

  const onChange = (e) => {
    console.log(e)
    setSelectedReason(e.target.value)
  }

  const confirmAction = async () => {

    setLoading(true);
    const formData = new FormData();
      formData.append("change_status",selectedAction);

    if(selectedReason){
      formData.append("reason", selectedReason);
    };

    const result = await updateUsersStatusForm(userId, formData);
    if(result){
      reload();
    }
    setLoading(false);
    setDialogOpen(false);
    setOpenSubMenu(false);
    setMenuOpen(false);
  };

  const handleSubOptionClick2 = (action, text) => {
    setSelectedAction2(action);
    setSelectedText2(text);
    setDialogOpen2(true); 
  };

  const onChange2 = (e) => {
    setSelectedReason2(e.target.value)
  }

  const confirmAction2 = async () => {

    setLoading(true);
    const formData = new FormData();
      formData.append("confirm_status",selectedAction2);

    if(selectedReason2){
      formData.append("reject_reason", selectedReason2);
    };

    const result = await updateConfirmUsersForm(userId, formData);
    if(result){
      reload();
    }
    setLoading(false);
    setDialogOpen2(false);
    setOpenSubMenu(false);
    setMenuOpen(false);
  };

  const closeSendNotification = () => {
    setNotificationDialog(false);
  };

  const handleSend = async (title, description) => {
    setLoadingSend(true)
    const formData = new FormData();
    formData.append("user_ids[]", userId);
    formData.append("title", title);
    formData.append("description", description);
    const result = await addNotificationsForm(formData);
    setLoadingSend(false);
    setNotificationDialog(false);
  };

  return (
    <div className="relative max-w-sm mx-auto bg-thirdly text-white rounded-xl shadow-lg p-6 space-y-6">
      <div className=" flex justify-between items-center w-full">
        <button className="rounded-full transition" onClick={() => setNotificationDialog(!notificationDialog)}>
          <NotificationAddIcon fontSize={"small"} className="hover:text-red-500" />
        </button>
        {notificationDialog && <NotificationDialog handleSend={handleSend} loadingSend={loadingSend} closeSendNotification={closeSendNotification} username={userData.user_name} />}
        <button onClick={() => setMenuOpen(!menuOpen)} className="rounded-full hover:text-red-500 transition">
          <CgMoreVertical  size={18} />
        </button>
        {menuOpen && (
          <div className="absolute top-3 left-14 ml-2 w-56 bg-gray-800 rounded-lg shadow-lg z-50">
              <div>
                {userData?.confirmStatus != null &&
                  <button onClick={() => toggleSubMenu("option1")} className="w-full flex justify-between items-center px-4 py-4  rounded-t-lg">
                    {t("user.verify_account")} <FaCircleChevronDown size={16} />
                  </button>
                }
                {openSubMenu === "option1" && (
                  <div className="bg-gray-700 text-sm">
                    <button className="block w-full text-left px-6 py-2 hover:bg-gray-600" onClick={() => handleSubOptionClick2("CONFIRMED", "Confirmed this user")}> {t("user.confirm")}</button>
                    <button className="block w-full text-left px-6 py-2 hover:bg-gray-600" onClick={() => handleSubOptionClick2("REJECT", "Rejected this user")}> {t("user.reject")}</button>
                  </div>
                )}
              </div>
            <div>
              <button onClick={() => toggleSubMenu("option2")} className="w-full flex justify-between items-center px-4 py-4 rounded-b-lg">
                {t("user.change_user_status")} <FaCircleChevronDown size={16} />
              </button>
              {openSubMenu === "option2" && (
                <div className="bg-gray-700 text-sm">
                  <button
                    onClick={() => handleSubOptionClick(1, "Active this user")}
                    className="block w-full text-left px-6 py-2 hover:bg-gray-600"
                  >
                     {t("user.active")}
                  </button>
                  <button
                    onClick={() => handleSubOptionClick(2, "Block this user")}
                    className="block w-full text-left px-6 py-2 hover:bg-gray-600"
                  >
                     {t("user.block")}
                  </button>
                  <button
                    onClick={() => handleSubOptionClick(3, "Suspend this user")}
                    className="block w-full text-left px-6 py-2 hover:bg-gray-600"
                  >
                     {t("user.suspend")}
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-col items-center justify-center">
        {userData?.photo == null ?
          <img src={defaultPhoto} alt="avatar" className="w-24 h-24 rounded-xl" />
          :
          <img src={userData?.photo} alt="avatar" className="w-24 h-24 rounded-xl" />
        }
        <h2 className="mt-4 text-xl font-semibold">{userData?.first_name } {" "} {userData?.last_name}</h2>
        <span className="mt-3 text-sm px-3 py-1 bg-secondary rounded-full"> {userData?.type}</span>
      </div>

      <div className="pt-3 border-t border-gray-600">
        <h3 className="text-lg font-semibold mb-3 text-center">{t("user.user_information")}</h3>
        <div className="flex flex-col justify-center items-start">
          {userData?.type == "company" && (<>
            <p className="text-md my-2">
              <span className="font-semibold">{t("user.company_name")} :</span> {userData?.company_name == null ? "undifined" : userData?.company_name}
            </p>
            <p className="text-md my-2">
              <span className="font-semibold">{t("user.commercial_number")} :</span> {userData?.commercial_register_number == null ? "undifined" : userData?.commercial_register_number }
            </p>
            </>
          )}
          <p className="text-md my-2">
            <span className="font-semibold">{t("user.username")} :</span> {userData?.user_name == null ? "undifined" : userData?.user_name}
          </p>
          <p className="text-md my-2">
            <span className="font-semibold">{t("user.email")} :</span> {userData?.email == null ? "undifined" : userData?.email}
          </p>
          <p className="text-md my-2">
            <span className="font-semibold">{t("user.phone_number")} :</span> {userData?.phone_number == null ? "undifined" : userData?.phone_number}
          </p>
          <p className="text-md my-2">
            {t("user.status")}  :
            <button className={`${userData.status == "active" ? "text-success" : userData?.status == "block" ? "text-danger" : "text-amber-700" } font-semibold rounded-md px-2 py-1`}> {userData?.status == null ? "undifined" : userData?.status} </button> 
          </p>
          <p className="text-md my-2">
            {t("user.account_status")} :
            <button className={`${userData.confirmStatus == "REJECT" ? "text-danger" : userData?.confirmStatus == "PENDING" ? "text-blue-600" :  userData?.confirmStatus == "CONFIRMED" ? "text-success" : "text-amber-700" } font-semibold rounded-md px-2 py-1`}> {userData?.confirmStatus == null ? "undifined" : userData?.confirmStatus} </button> 
          </p>
          <p className="text-md my-2">
            <span className="font-semibold">{t("user.address")} :</span> {userData?.address == null ? "undifined" : userData?.address}
          </p>
          <p className="text-md my-2">
            <span className="font-semibold">{t("user.bio")} :</span> {userData?.bio == null ? "undifined" : userData?.bio}
          </p>
          <p className="text-md my-2">
            <span className="font-semibold">{t("user.register")} :</span> {userData?.register_by == null ? "undifined" : userData?.register_by}
          </p>
          <p className="text-md my-2">
            <span className="font-semibold">{t("user.created_at")} :</span> {userData?.created_at == null ? "undifined" : userData?.created_at}
          </p>
          <p className="text-md my-2 ">
            <span className="font-semibold">{t("user.email_verified")} :</span> {userData?.email_verified == null ? "undifined" : userData?.email_verified}
          </p>
          <p className="text-md my-2 ">
            <span className="font-semibold">{t("user.last_seen")} :</span> {userData?.last_seen == null ? "undifined" : userData?.last_seen}
          </p>
        </div>
      </div>
      <div className="pt-3 border-t border-gray-600">
        <h3 className="text-lg font-semibold mb-3 text-center flex flex-row justify-center items-center gap-2">Account <h3 className="text-secondary">{userData?.type?.toUpperCase()}</h3> Verify </h3>
        {userData.type == "company"
          ?
            <img src={userData.confirm_photo_1} className="w-full h-48"/>
          :
          (<>
            <img src={userData.confirm_photo_1} className="w-full h-48 mb-4"/>
            <img src={userData.confirm_photo_2} className="w-full h-48"/>
          </>)
        }
      </div>
      {dialogOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-gray-800 text-white rounded-lg shadow-lg p-6 sm:w-96 w-80">
            <h3 className="text-xl font-semibold mb-4 text-center">{t("user.confirm_action")}</h3>
            <p className="mb-4 text-md text-center">
                {t("user.are_you_sure")}{" "}
              <span className="font-bold">{selectedText}</span>
              {
                (selectedAction == 2 || selectedAction == 3) &&
                <div className="my-4">
                  <InputFieldWithIcon placeholder={t("user.what_is_the_reason")} onchange={(e) => onChange(e)} />
                </div>
              }
            </p>
            <div className="flex justify-center gap-8">
              <button
                onClick={() => setDialogOpen(false)}
                className="px-4 py-2 rounded-md bg-gray-600 hover:bg-gray-500"
              >
                {t("user.cancel")}
              </button>
              <button onClick={confirmAction} disabled={loading} className="px-4 py-2 rounded-md bg-green-600 hover:bg-green-500" >
                {loading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                        </>
                    ) : (
                        t("user.confirm")
                    )}
              </button>
            </div>
          </div>
        </div>
      )}
      {dialogOpen2 && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-gray-800 text-white rounded-lg shadow-lg p-6 sm:w-96 w-80">
            <h3 className="text-xl font-semibold mb-4 text-center">{t("user.confirm_action")}</h3>
            <p className="mb-4 text-md text-center">
              {t("user.are_you_sure")}{" "}
              <span className="font-bold">{selectedText2}</span>
              {
                (selectedAction2 == "REJECT" ) &&
                <div className="my-4">
                  <InputFieldWithIcon placeholder={" what is the reason ? (require) "} onchange={(e) => onChange2(e)} />
                </div>
              }
            </p>
            <div className="flex justify-center gap-8">
              <button
                onClick={() => setDialogOpen2(false)}
                className="px-4 py-2 rounded-md bg-gray-600 hover:bg-gray-500"
              >
                {t("user.cancel")}
              </button>
              <button onClick={confirmAction2} disabled={loading} className="px-4 py-2 rounded-md bg-green-600 hover:bg-green-500" >
                {loading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                        </>
                    ) : (
                        t("user.confirm")
                    )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
